// extracted by mini-css-extract-plugin
module.exports = {"imageTop":"styles-module--imageTop--1rSkh","imageBottom":"styles-module--imageBottom--3yj3F"};